export default "__VITE_ASSET__CTlRlhGA__"